import React from 'react';
import DashboardCard, { type DashboardCardSize } from 'components/DashboardCard/DashboardCard';

export type AnnouncementVariant = 'default' | 'success' | 'warning' | 'danger' | 'error' | 'blue' | 'blueGrey';

export type AnnouncementProps = {
    variant?: AnnouncementVariant;
    headerContent?: React.ReactNode;
    size?: DashboardCardSize;
    children?: React.ReactNode;
};

const Announcement = React.memo(
    ({ variant = 'default', headerContent = '', size = 'xl', children }: AnnouncementProps) => (
        <DashboardCard color={getColor(variant)} headerContent={headerContent} size={size} variant="full">
            {children}
        </DashboardCard>
    )
);

function getColor(variant: AnnouncementVariant): 'grey' | 'lightGreen' | 'amber' | 'red' | 'blue' | 'blueGrey' {
    switch (variant) {
        case 'success':
            return 'lightGreen';
        case 'warning':
            return 'amber';
        case 'danger':
        case 'error':
            return 'red';
        case 'blue':
            return 'blue';
        case 'blueGrey':
            return 'blueGrey';
        default:
            return 'grey';
    }
}

export default Announcement;
